import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-file-uploading-status-box',
  templateUrl: './file-uploading-status-box.component.html',
  styleUrls: ['./file-uploading-status-box.component.scss'],
})
export class FileUploadingStatusBoxComponent implements OnInit {
  @Output() fileCancelUpload = new EventEmitter<any>();

  loadingPercentage: any;
  filesStatus: { id: number; name: string; percentage: number; drag: boolean }[] = [];
  @Input() filesProgress: Observable<any> = null;
  isCollapsed: boolean = true;
  // isClosed: boolean = false

  constructor() {}

  ngOnInit(): void {
    this.filesProgress.subscribe((result: any) => {
      this.filesStatus = result;
    });
  }
  cancelImgUpload(file, ind) {
    this.fileCancelUpload.emit(file?.name);
    // this.fileCancelUpload.emit({file: file, index:ind})
    this.filesStatus.splice(ind, 1);
  }
  message = 'expanded';

  collapsed(): void {
    this.message = 'collapsed';
  }

  collapses(): void {
    this.message = 'collapses';
  }

  expanded(): void {
    this.message = 'expanded';
  }

  expands(): void {
    this.message = 'expands';
  }
}
